/*       */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bind } from 'app/utils/decorators/decoratorUtils';
import ModalFormGenearator from 'app/components/organisms/ModalFormGenearator/ModalFormGenearator';

class RadioValueModal extends PureComponent {
    static propTypes = {
        open: PropTypes.bool.isRequired,
        value: PropTypes.shape({
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            label: PropTypes.string,
            helperText: PropTypes.string,
            icon: PropTypes.string,
        }),
        onClose: PropTypes.func.isRequired,
        onSave: PropTypes.func.isRequired,
        onRemove: PropTypes.func,
    };

    getFormComponents() {
        const { value, onRemove } = this.props;

        const components = [
            {
                type: 'text',
                properties: {
                    name: 'value',
                    label: 'Value*',
                    placeholder: 'Enter unique identifier',
                },
                constraints: {
                    required: true,
                },
            },
            {
                type: 'text',
                properties: {
                    name: 'label',
                    label: 'Label*',
                    placeholder: 'Enter display text',
                },
                constraints: {
                    required: true,
                },
            },
            {
                type: 'text',
                properties: {
                    name: 'helperText',
                    label: 'Helper text',
                    placeholder: 'Additional information or warning (optional)',
                },
            },
            {
                type: 'iconSelect',
                properties: {
                    name: 'icon',
                    label: 'Icon',
                    placeholder: 'Select icon (optional)',
                },
            },
        ];

        // Add remove button only when editing existing value
        if (value && onRemove) {
            components.push({
                type: 'button',
                properties: {
                    label: 'REMOVE VALUE',
                    iconName: 'delete',
                    fullWidth: false,
                    onClick: onRemove,
                },
            });
        }

        components.push(
            {
                type: 'divider',
            },
            {
                type: 'displayText',
                properties: {
                    text: '* All fields are required',
                    styledRules: 'color: rgba(255, 255, 255, 0.5); font-size: 0.75rem;margin-top: -16px;',
                },
            }
        );

        return components;
    }

    @bind
    handleChange(event) {
        const { onSave } = this.props;
        const data = event.target.value;

        // Convert value to number if it's numeric
        const radioValue = {
            value: !isNaN(Number(data.value)) && data.value !== '' ? Number(data.value) : data.value,
            label: data.label,
        };

        if (data.helperText) {
            radioValue.helperText = data.helperText;
        }

        if (data.icon) {
            radioValue.icon = data.icon;
        }

        onSave(radioValue);
    }

    render() {
        const { open, onClose, value } = this.props;

        const formData = {
            value: value?.value !== undefined && value?.value !== null ? value?.value : '',
            label: value?.label || '',
            helperText: value?.helperText || '',
            icon: value?.icon || '',
        };

        return (
            <ModalFormGenearator
                isOpen={open}
                title={value ? 'Edit Value' : 'Add Value'}
                components={this.getFormComponents()}
                value={formData}
                onChange={this.handleChange}
                onClose={onClose}
                withoutPreview
                labelSubmitButton="APPLY"
            />
        );
    }
}

export default RadioValueModal;
